// extracted by mini-css-extract-plugin
export var author = "Author-module--author--y9MUW";
export var link = "Author-module--link--CcF2i";
export var photo = "Author-module--photo--l4ewo";
export var subtitle = "Author-module--subtitle--huxcU";
export var title = "Author-module--title--z35RG";